<template>
    <div
        v-if="!isStep7Complete"
        class="bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 overflow-hidden col-span-12 md:col-span-6 flex flex-col"
    >
        <div class="p-6 flex flex-col gap-4">
            <!-- Header -->
            <div class="flex items-center justify-between">
                <div
                    class="flex items-center gap-2 text-lg font-medium text-slate-800 dark:text-slate-200"
                >
                    <icon icon="pass" :width="20" :height="20" />
                    Companion pass
                </div>
                <a
                    href="/companionpass/"
                    class="text-sm font-medium text-slate-800 dark:text-slate-200 hover:text-slate-700 dark:hover:text-slate-300 flex items-center gap-1"
                    id="hs-dashboard-companion-pass"
                >
                    View details
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="w-4 h-4"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </a>
            </div>

            <!-- Illustration + Step counter -->
            <div class="relative">
                <div class="flex justify-center">
                    <div class="relative">
                        <img
                            src="/images/companionpass/graphics-companionpass-default.png"
                            alt="Southwest Companion Pass"
                            class="h-auto"
                            style="max-width: 280px"
                        />
                        <div
                            class="hidden dark:block absolute inset-0 pointer-events-none"
                            style="
                                background: radial-gradient(
                                    ellipse 72% 72% at 50% 45%,
                                    transparent 40%,
                                    #1e293b 84%
                                );
                            "
                        ></div>
                    </div>
                </div>
                <p
                    class="absolute bottom-0 left-0 text-sm font-medium text-slate-500 dark:text-slate-400"
                >
                    {{ currentStep }} of 7 steps
                </p>
            </div>

            <!-- Step info -->
            <div>
                <h3
                    class="text-2xl font-semibold text-slate-800 dark:text-slate-100 leading-8 mb-2"
                >
                    {{ currentStepsContent.title }}
                </h3>
                <p class="text-sm font-normal text-slate-500 dark:text-slate-400">
                    {{ currentStepsContent.nextLine1 }}
                    {{ currentStepsContent.nextLine2 }}
                </p>
            </div>

            <!-- Progress bar -->
            <div class="w-full rounded-full" style="background-color: #ffeae6">
                <div
                    class="h-1 rounded-full bg-orange transition-all"
                    :style="{ width: (currentStep / 7) * 100 + '%' }"
                ></div>
            </div>

            <!-- View more button (mobile only) -->
            <a
                href="/companionpass/"
                class="sm:hidden flex items-center justify-center w-full py-3 mt-2 text-base font-medium text-white rounded-lg"
                style="background: #fd421d"
            >
                View more
            </a>
        </div>
    </div>
    <section-8-congratulations v-if="isStep7Complete || isStep8Visible" />
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useDashboardStore } from '@/store/dashboard';
import { useCompanionPassStore } from '@/store/companionpass';
import Icon from '@/components/ui/icon/icon.vue';
import Section8Congratulations from '@/components/companion-pass/tap-sections/section-8-congratulations.vue';

export default {
    props: [],
    components: { Icon, Section8Congratulations },
    computed: {
        ...mapState(useDashboardStore, ['loading']),
        ...mapState(useCompanionPassStore, ['steps', 'completeSteps']),
        stepsToComplete() {
            let count = 0;
            this.steps.forEach((bar) => {
                if (!bar.complete) {
                    count++;
                }
            });
            return count;
        },
        finStepNum() {
            if (8 in this.completeSteps) {
                return 8;
            }
            if (7 in this.completeSteps) {
                return 7;
            }
            if (6 in this.completeSteps) {
                return 6;
            }
            if (5 in this.completeSteps) {
                return 5;
            }
            if (4 in this.completeSteps) {
                return 4;
            }
            if (3 in this.completeSteps) {
                return 3;
            }
            if (2 in this.completeSteps) {
                return 2;
            }
            return 1;
        },
        nextStepNum() {
            return this.finStepNum;
        },
        nextNextStepNum() {
            if (this.finStepNum < 7) {
                return this.finStepNum + 1 + '.';
            } else {
                return '';
            }
        },
        currentStepsContent() {
            if (8 in this.completeSteps) {
                return this.stepsContent[8];
            }
            if (7 in this.completeSteps) {
                return this.stepsContent[7];
            }
            if (6 in this.completeSteps) {
                return this.stepsContent[6];
            }
            if (5 in this.completeSteps) {
                return this.stepsContent[5];
            }
            if (4 in this.completeSteps) {
                return this.stepsContent[4];
            }
            if (3 in this.completeSteps) {
                return this.stepsContent[3];
            }
            if (2 in this.completeSteps) {
                return this.stepsContent[2];
            }
            if (1 in this.completeSteps) {
                return this.stepsContent[1];
            }

            return this.stepsContent[0];
        },
        currentStep() {
            return this.finStepNum;
        },
        totalSteps() {
            return this.steps.length;
        },
        isStep7Complete() {
            return this.steps.find((step) => step.id === 7 && step.complete);
        },
        isStep8Visible() {
            return this.steps.find((step) => step.id === 8 && step.complete);
        },
    },
    data: () => ({
        stepsContent: [
            {
                title: 'Open 1st Southwest credit card',
                nextLine1:
                    'Your first step in earning your Companion Pass will be ',

                nextLine2: 'to open a Southwest Credit Card.',
            },
            {
                title: 'Finish adding card details to your My10x Wallet',
                nextLine1:
                    "You've added your first Southwest card to your wallet, but we need more info.",
                nextLine2: '',
            },
            {
                title: 'Wait at least 30 days',
                nextLine1:
                    'Some patience is required for this step - sit tight for 30 days before starting your next step.',
                nextLine2:
                    'Your next step in earning your Companion Pass will be to open a second Southwest Credit Card.',
            },
            {
                title: 'Open your second Southwest credit card',
                nextLine1:
                    'Your next step in earning your Companion Pass will be to open a second Southwest Credit Card.',
                nextLine2:
                    "After you've opened your 2nd Southwest Credit Card, add it to your My10x Wallet.",
            },
            {
                title: 'Finish adding card details to your My10x Wallet',
                nextLine1:
                    "You've added your second Southwest card to your wallet, but we need more info.",
                nextLine2: '',
            },
            {
                title: 'Wait until 1/1/2026',
                nextLine1:
                    "Sit back, relax, and whatever you do, don't meet the minimum spend on either card prior to 1/1/2026.",
                nextLine2:
                    "You're free and clear to meet the minimum spends now on both of your Southwest Credit Cards.",
            },
            {
                title: 'Meet minimum spends',
                nextLine1:
                    "You're free and clear to meet the minimum spends now on both of your Southwest Credit Cards.",
                nextLine2:
                    "You've done your part - now you just have to wait for your Companion Pass to post to your Southwest Rapid Rewards account.",
            },
            {
                title: 'Congratulations! ' + 'You’ve done your part',
                nextLine1:
                    'You’ve  met the criteria to earn Southwest companion pass - now you',
                nextLine2:
                    'just have to wait for your Companion pass to post to your southwest rapid rewards account.',
            },
        ],
    }),
    methods: {
        ...mapActions(useCompanionPassStore, [
            'getPassData',
            'getSteps',
            'updateCompleteSteps',
            'setPassEnabled',
            'togglePass',
        ]),
    },
    created() {},
    mounted() {
        this.getSteps();
        this.updateCompleteSteps();
    },
};
</script>
